import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class SearchDialogDropdown extends BaseComponent {
    properties() {
        return {};
    }

    connected() {
        this._form = document.getElementById('search-form');
        this._input = document.getElementById('search-input');
    }

    events() {
        return {
            '[data-suggestion]': {
                click: (e) => {
                    this._input.value = e.target.closest('[data-suggestion]').getAttribute('data-suggestion');
                    this._form.submit();
                },
            },
        };
    }
}

defineComponent('search-dialog-dropdown', SearchDialogDropdown);
